
const ConfigProduction = {
  // serverEndpoint: 'https://mgwbd-api.azurewebsites.net',
  serverEndpoint: '/api',
  clientFlagConfig: [
    {
      'canonicalName': 'showWipGames',
      'displayName': 'Show games still under development',
      'values': [true, false],
      'defaultValue': false,
    },
  ],
}


const ConfigDevelopment = {
  ...ConfigProduction,
  serverEndpoint: '/api',
  // serverEndpoint: 'http://localhost:5000',
  // serverEndpoint: 'https://mgwbd-api.azurewebsites.net',
  withCredentials: true,
};


const Config = {
  'development': ConfigDevelopment,
  'production': ConfigProduction,
}[process.env.NODE_ENV];


export default Config;

